module.exports = __webpack_public_path__ + "img/GAME_NIGHTSKY.62bc873b.jpg";